<template>
    	<div id="signUpSocial" class="signUpSocial">
    		<div class="header">
          <p>Sign in to customise your experience and manage your notifications.</p>
        </div>
        <div class="buttons">
            <button class="btn google" @click="googleLogin"><i class="icon-google"></i>Continue with Google</button>
            <button class="btn facebook" @click="facebookLogin"><i class="icon-facebook"></i>Continue with Facebook</button>
            <button class="btn emailBtn" @click="$router.push({ path: '/login/email' })"><i class="icon-mail"></i>Sign In with Email</button>
            <hr>
            <button class="btn backBtn" @click="$router.push({ path: '/login/register' })">Register a new Account with Email</button>
            <a class="guest" @click="$router.push({ path: '/' })">Continue as guest</a>
        </div>
        <footer>
        <p><small>The eThekwini Municipality will not be held responsible for any changes, omissions or inaccuracies contained herein which may result in unforeseen expense, injury or other misfortune.</small></p>
      </footer>
		</div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'login-social',
  data: function () {
    return {

    }
  },
  methods: {
    facebookLogin: function () {
      this.getFacebookLoginUrl()
        .then((response) => {
          window.location.href = response.data
        })
    },
    googleLogin: function () {
      this.getGoogleLoginUrl()
        .then((response) => {
          window.location.href = response.data
        })
    },
    ...mapActions([
      'getFacebookLoginUrl', 'getGoogleLoginUrl'
    ])
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/login/Login.vue